/* eslint-disable perfectionist/sort-jsx-props */
/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";

type Props = {
  className?: string;
};

export const BmwLogo: FunctionComponent<Props> = ({ className }) => (
  <svg
    className={clsx("block", className)}
    fill="none"
    viewBox="0 0 341 341"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#6F6F6F"
      fillRule="evenodd"
      d="M170.08 0C76.15 0 0 76.15 0 170.08s76.15 170.08 170.08 170.08 170.08-76.15 170.08-170.08S264.01 0 170.08 0ZM329.1 170.08c0 87.82-71.19 159.02-159.02 159.02-87.83 0-159.02-71.2-159.02-159.02 0-87.82 71.2-159.02 159.02-159.02 87.82 0 159.02 71.2 159.02 159.02ZM170.08 69.22v5.53c52.56 0 95.33 42.76 95.33 95.33h5.53c0-55.7-45.16-100.86-100.86-100.86Zm0 196.19c-52.56 0-95.33-42.76-95.33-95.33h-5.53c0 55.7 45.16 100.86 100.86 100.86v-5.53Zm89.94-158.58c-1.87-2.43-5.2-6.43-7.51-8.91l10.67-20.6.97-1.32-1.32.97-20.58 10.68c-2.33-2.13-5.98-5.26-8.75-7.39l21.86-34.41c3.11 2.4 5.55 4.38 8.09 6.54l-14.43 21.8-1.29 1.49 1.62-1.11 19.23-9.63 6.81 6.81-9.63 19.22-1.11 1.62 1.49-1.28 21.81-14.42a229.004 229.004 0 0 1 6.51 8.08l-34.44 21.86Zm-85.66-52.52 9.41-21.08.6-1.87-.17 1.95.99 28.17c3.3.31 6.71.77 10.07 1.33l-1.53-41.72c-4.7-.52-9.38-.89-14.06-1.09l-9.27 23.01-.33 1.71-.33-1.71L160.48 20c-4.68.2-9.36.57-14.06 1.09l-1.53 41.72c3.36-.56 6.77-1.01 10.07-1.33l.99-28.17-.17-1.95.6 1.87 9.41 21.08h8.57Zm-73.03 14.58c5.44 6.32 2.36 12.94-3.08 18.67-1.61 1.697-3.058 3.214-4.43 4.652-5.169 5.418-9.262 9.709-16.96 18.228L47.47 82.56c2.82-3.68 7.52-9.36 10.75-12.96 10.7-11.93 14.63-15.42 19.74-15.94 2.74-.28 5.45.37 7.61 2.12C90 59.37 89.61 64.57 89 66.2l-.13.36.41-.16c4.12-1.69 9.09-.94 12.05 2.49Zm-26.37-4.56c-2.85 2.6-9.14 9.17-15.06 16.41l5.7 5.43s11.48-12.01 14.61-15.54c1.39-1.56 2.64-3.45 2.19-5.44-.45-1.98-2.44-3.35-4.37-2.82-1.19.32-2.17 1.14-3.07 1.96Zm11.28 11.73c-3.65 3.78-14.83 15.6-14.83 15.6l5.96 5.65c.02-.02 13.28-14.21 14.82-15.86 1.14-1.23 2.52-2.84 2.89-4.53.31-1.42-.26-2.85-1.5-3.68-1.26-.84-2.67-.71-3.96-.08-1 .49-1.93 1.4-3.38 2.9Z"
      clipRule="evenodd"
    />
    <path
      fill="#0066B1"
      d="M170.08 69.22v100.86H69.22c0-55.74 45.12-100.86 100.86-100.86Zm100.86 100.86c0 55.74-45.12 100.86-100.86 100.86V170.08h100.86Z"
    />
  </svg>
);
